import { render } from "./Slider.vue?vue&type=template&id=70e4af4f"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"
script.render = render

export default script